/**
 * iCure Data Stack API Documentation
 * The iCure Data Stack Application API is the native interface to iCure. This version is obsolete, please use v2.
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { CommentedClassification } from './CommentedClassification'
import { SamText } from './SamText'
import { VmpComponent } from './VmpComponent'
import { VmpGroupStub } from './VmpGroupStub'
import { Vtm } from './Vtm'
import { Wada } from './Wada'
import {Quantity} from "./Quantity"

export class Vmp {
  constructor(json: JSON | any) {
    Object.assign(this as Vmp, json)
  }

  id?: string
  rev?: string
  /**
   * hard delete (unix epoch in ms) timestamp of the object. Filled automatically when deletePatient is called.
   */
  deletionDate?: number
  from?: number
  to?: number
  code?: string
  vmpGroup?: VmpGroupStub
  singleAdministrationDose?: Quantity
  name?: SamText
  abbreviation?: SamText
  vtm?: Vtm
  wadas?: Array<Wada>
  components?: Array<VmpComponent>
  commentedClassifications?: Array<CommentedClassification>
}
